<template>
  <div class="picture-quality-error">
    <img class="picture-quality-img" src="@/assets/warning.svg" alt="warning">
    <p class="picture-quality-text t-bold">{{ hasError.get('documentImage') }}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
props: {
    front: Boolean,
  },
  computed: {
    ...mapState({
      //@ts-ignore
      hasError: (state) => state.errors,
    }),
  },
}
</script>
